<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import BlackTubingImage from './images/black_tubing.png';
	import BrownTubingImage from './images/brown_tubing.png';
	import WhiteTubingImage from './images/white_tubing.png';
	export let title = 'The tubing comes in three colors:';
</script>

<Section>
	<h2>{title}</h2>
	<slot />
	<Image alt="indow window brown compression tubing" src={BrownTubingImage}>
		{#snippet descriptionSlot()}
			<p>Brown</p>
		{/snippet}
	</Image>
	<Image alt="indow window black compression tubing" src={BlackTubingImage}>
		{#snippet descriptionSlot()}
			<p>Black</p>
		{/snippet}
	</Image>

	<Image alt="indow window white compression tubing" src={WhiteTubingImage}>
		{#snippet descriptionSlot()}
			<p>Warm White</p>
		{/snippet}
	</Image>
</Section>
